export default __webpack_public_path__ + "static/media/asmir.46020149.jpg";